import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import "./styles.scss";

const createOption = (value, formatter) =>
  formatter ? formatter(value) : { value, label: value };

const MultiInput = ({
  placeholder,
  optionFormatter,
  value,
  onChange,
  ...props
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = newValue => {
    onChange(newValue || []);
  };

  const validateAndSetValue = newValues => {
    onChange([
      ...value,
      ...newValues.filter(
        val => val && !value.find(prevVal => prevVal.value === val.value)
      )
    ]);
  };

  const handleInputChange = inputValue => {
    const splitVals = inputValue.split(/[,;]/g);
    setInputValue(
      inputValue.endsWith(",") || inputValue.endsWith(";")
        ? ""
        : splitVals.pop()
    );

    if (splitVals.length > 0) {
      validateAndSetValue(
        splitVals
          .map(val => val.trim())
          .filter(val => val !== "")
          .map(val => createOption(val.trim(), optionFormatter))
      );
    }
  };

  const handleKeyDown = e => {
    if (inputValue && ["Enter", "Tab"].includes(e.key)) {
      validateAndSetValue([createOption(inputValue.trim(), optionFormatter)]);
      setInputValue("");
    }
  };

  const handleBlur = () => {
    if (inputValue) {
      validateAndSetValue([createOption(inputValue.trim(), optionFormatter)]);
    }
  };

  useEffect(() => {
    onChange && onChange(value);
  }, [value, onChange]);

  return (
    <CreatableSelect
      className="multi-input"
      components={{ DropdownIndicator: null }}
      inputValue={inputValue}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      value={value}
      placeholder={placeholder || ""}
      {...props}
    />
  );
};

export default MultiInput;
